/**
 * User: Rob Richard
 * Date: 1/17/14
 * Time: 5:44 PM
 */

"use strict";

var SoaModel = require('bunsen/models/SoaModel');
var Permission = module.exports = SoaModel.extend();
var _ = require('underscore');
var Backbone = require('dibs-backbone');
var endpoints = require('dibs-endpoints');
var bunsen = require('bunsen/libraries/bunsen');
var Roles = require('bunsen/collections/identity/Roles');

bunsen.Permission = Permission;


_.extend(Permission, {
    'PERMISSION_ACCOUNT_REP' : 'ACCOUNT_REP',
    'PERMISSION_ASSIGN_ROLES' : 'ASSIGN_ROLES',
    'PERMISSION_BASIC_INTERNAL' : 'BASIC_INTERNAL',
    'PERMISSION_BULK_UPDATE_ACCESS' : 'BULK_UPDATE_ACCESS',
    'PERMISSION_B_NET_PRICE' : 'B_NET_PRICE',
    'PERMISSION_B_TAX_EXEMPT' : 'B_TAX_EXEMPT',
    'PERMISSION_B_TRADE_CHECKOUT' : 'B_TRADE_CHECKOUT',
    'PERMISSION_B_VIP_CHECKOUT' : 'B_VIP_CHECKOUT',
    'PERMISSION_CMS_ACCESS' : 'CMS_ACCESS',
    'PERMISSION_CONTROL_PERMISSIONS' : 'CONTROL_PERMISSIONS',
    'PERMISSION_CREATE_ACCOUNT' : 'CREATE_ACCOUNT',
    'PERMISSION_CREATE_TEST_ITEMS' : 'CREATE_TEST_ITEMS',
    'PERMISSION_CREATORS_ACCESS' : 'CREATORS_ACCESS',
    'PERMISSION_CUSTOMER_ACCESS' : 'CUSTOMER_ACCESS',
    'PERMISSION_CUSTOMER_DISABLE_ACCOUNT' : 'CUSTOMER_DISABLE_ACCOUNT',
    'PERMISSION_DEALER_ACCESS' : 'DEALER_ACCESS',
    'PERMISSION_DEALER_ACCESS_STATEMENT' : 'DEALER_ACCESS_STATEMENT',
    'PERMISSION_DEALER_EDIT_ACCOUNT' : 'DEALER_EDIT_ACCOUNT',
    'PERMISSION_DEALER_EDIT_LOCATION' : 'DEALER_EDIT_LOCATION',
    'PERMISSION_DEALER_EDIT_STATUS' : 'DEALER_EDIT_STATUS',
    'PERMISSION_DEALER_EDIT_STOREFRONT' : 'DEALER_EDIT_STOREFRONT',
    'PERMISSION_DEVELOPER_TOOLS_ACCESS' : 'DEVELOPER_TOOLS_ACCESS',
    'PERMISSION_EDITORIAL_CMS_ACCESS' : 'EDITORIAL_CMS_ACCESS',
    'PERMISSION_ELIGIBILITY_DATE_DELAY': 'ELIGIBILITY_DATE_DELAY',
    'PERMISSION_EXPERT_REVIEW_REJECT': 'EXPERT_REVIEW_REJECT',
    'PERMISSION_DEALER_EDIT_MIN_INVENTORY': 'DEALER_EDIT_MIN_INVENTORY',
    'PERMISSION_DEALER_EDIT_POLICY_FIELDS': 'DEALER_EDIT_POLICY_FIELDS',
    'PERMISSION_FINANCE_BULK_UPDATE' : 'FINANCE_BULK_UPDATE',
    'PERMISSION_HYPERWALLET_ACCOUNT_CREATE': 'HYPERWALLET_ACCOUNT_CREATE',
    'PERMISSION_INTERNAL_ADMIN_USER' : 'INTERNAL_ADMIN_USER',
    'PERMISSION_ITEM_ACCESS' : 'ITEM_ACCESS',
    'PERMISSION_ITEM_ACTION' : 'ITEM_ACTION',
    'PERMISSION_ITEM_EDIT_LOCKED' : 'ITEM_EDIT_LOCKED',
    'PERMISSION_ITEM_IMAGE_UNLOCK' : 'ITEM_IMAGE_UNLOCK',
    'PERMISSION_MASQUERADE_AS_BUYER' : 'MASQUERADE_AS_BUYER',
    'PERMISSION_MASQUERADE_AS_DEALER' : 'MASQUERADE_AS_DEALER',
    'PERMISSION_MOBILE_PUBLISH_DISCOVER' : 'MOBILE_PUBLISH_DISCOVER',
    'PERMISSION_MOBILE_CREATE_DISCOVER' : 'MOBILE_CREATE_DISCOVER',
    'PERMISSION_MOBILE_PUBLISH_NOTIFICATION' : 'MOBILE_PUBLISH_NOTIFICATION',
    'PERMISSION_MOBILE_CREATE_NOTIFICATION' : 'MOBILE_CREATE_NOTIFICATION',
    'PERMISSION_OMT_ACCESS' : 'OMT_ACCESS',
    'PERMISSION_OMT_ACCOUNTING' : 'OMT_ACCOUNTING',
    'PERMISSION_OMT_CANCEL_ORDER' : 'OMT_CANCEL_ORDER',
    'PERMISSION_OMT_ENTER_SHIPPING_MILESTONES' : 'OMT_ENTER_SHIPPING_MILESTONES',
    'PERMISSION_OMT_ENTER_SHIPPING_QUOTE' : 'OMT_ENTER_SHIPPING_QUOTE',
    'PERMISSION_OMT_SHIPPING_EXCEPTIONS' : 'OMT_SHIPPING_EXCEPTIONS',
    'PERMISSION_OMT_FLAG_MESSAGE' : 'OMT_FLAG_MESSAGE',
    'PERMISSION_OMT_FRAUD_ACTIONS' : 'OMT_FRAUD_ACTIONS',
    'PERMISSION_OMT_MASQUERADE_AS_BUYER' : 'OMT_MASQUERADE_AS_BUYER',
    'PERMISSION_OMT_MASQUERADE_AS_DEALER' : 'OMT_MASQUERADE_AS_DEALER',
    'PERMISSION_OMT_SUPPORT_REP' : 'OMT_SUPPORT_REP',
    'PERMISSION_PHOTO_ACCESS' : 'PHOTO_ACCESS',
    'PERMISSION_PUB_ATTACH_ADDTL_LISTINGS': 'PUB_ATTACH_ADDTL_LISTINGS',
    'PERMISSION_PUB_CREATE': 'PUB_CREATE',
    'PERMISSION_PUB_CREATE_SAT_SALE': 'PUB_CREATE_SAT_SALE',
    'PERMISSION_PUB_DASHBOARD_ACCESS': 'PUB_DASHBOARD_ACCESS',
    'PERMISSION_PUB_DELETE': 'PUB_DELETE',
    'PERMISSION_PUB_DELETE_ACTIVE': 'PUB_DELETE_ACTIVE',
    'PERMISSION_PUB_EDIT_ACCESS': 'PUB_EDIT_ACCESS',
    'PERMISSION_PUB_LISTING_NOTES': 'PUB_LISTING_NOTES',
    'PERMISSION_PUB_MERCHANDISING': 'PUB_MERCHANDISING',
    'PERMISSION_PUB_PROMOTE_DEMOTE': 'PUB_PROMOTE_DEMOTE',
    'PERMISSION_PUB_PUBLISH': 'PUB_PUBLISH',
    'PERMISSION_PUB_RESCEDULE_LISTINGS': 'PUB_RESCHEDULE_LISTINGS',
    'PERMISSION_PUB_TRANSITION_PUBLICATION': 'PUB_TRANSITION_PUBLICATION',
    'PERMISSION_PUBLISH_INVENTORY' : 'PUBLISH_INVENTORY',
    'PERMISSION_REFUND_CREATE' : 'REFUND_CREATE',
    'PERMISSION_REVIEW_APPROVE_PHOTO_DOCUMENT': 'REVIEW_APPROVE_PHOTO_DOCUMENT',
    'PERMISSION_REVIEW_APPROVE_DATA_DOCUMENT': 'REVIEW_APPROVE_DATA_DOCUMENT',
    'PERMISSION_REVIEW_DATA_ASSIGN': 'REVIEW_DATA_ASSIGN',
    'PERMISSION_REVIEW_DATA_QUEUE': 'REVIEW_DATA_QUEUE',
    'PERMISSION_REVIEW_PHOTO_ASSIGN': 'REVIEW_PHOTO_ASSIGN',
    'PERMISSION_REVIEW_PHOTO_NOTES': 'REVIEW_PHOTO_NOTES',
    'PERMISSION_REVIEW_PHOTO_PROCESSING_QUEUE': 'REVIEW_PHOTO_PROCESSING_QUEUE',
    'PERMISSION_STOREFRONT_V2_MANAGER': 'STOREFRONT_V2_MANAGER',
    'PERMISSION_VERIFY_TRADE_USER' : 'VERIFY_TRADE_USER',
    'PERMISSION_VERIFY_VIP_USER' : 'VERIFY_VIP_USER',
    'PERMISSION_WIRE_CREATE' : 'WIRE_CREATE',
    'PERMISSION_WIRE_CONFIRM' : 'WIRE_CONFIRM',
    'PERMISSION_WIRE_VIEW_DETAILS' : 'WIRE_VIEW_DETAILS',
    'PERMISSION_VETTING_FILTERING' : 'VETTING_FILTERING',
    'PERMISSION_REVIEW_VETTING_IN_PROGRESS': 'REVIEW_VETTING_IN_PROGRESS',
    'PERMISSION_REVIEW_VETTING_APPROVED': 'REVIEW_VETTING_APPROVED',
    'PERMISSION_REVIEW_VETTING_VOID': 'REVIEW_VETTING_VOID'
});

_.extend(Permission.prototype, {
    relations: [
        {
            type: Backbone.Many,
            key: 'roles',
            collectionType: Roles,
            omitFromSave: true
        }
    ],
    url: function () {
        return endpoints.permission(this.get(this.idAttribute));
    },
    initialize: function () {
        _.bindAll(this, 'removePermissionFromRole', 'addPermissionToRole');
    },
    removePermissionFromRole: function (roleId, passedOptions) {
        var options = passedOptions || {};
        var url = endpoints.permissionsByRole(roleId, this.get('id'));

        // Sync here instead of destroy because event's shouldn't be triggered
        return this.sync('delete', this, _.defaults(options, {
            url: url
        }));
    },
    addPermissionToRole: function (roleId, passedOptions) {
        var options = passedOptions || {};
        var url = endpoints.permissionsByRole(roleId, this.get('id'));

        return this.sync('create', this, _.defaults(options, {
            url: url
        }));
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/identity/Permission.js
// module id = 936
// module chunks = 63